<template>
  <div class="my-div" >
    <div class="level is-mobile">
           <div  style="width: 100%;">
            <h1 class="title">Vigencia: {{ selectedMonthName() }} del {{ selectedYear }}</h1>
          </div>
        </div>
    <section class="section">
      <div class="container">

        <div class="columns">
          <div class="column">
           
              <select placeholder="Seleccionar" v-model="zone" required @change="getData" style="margin-bottom: 20px">
                <option value="1">Zona A</option>
                <option value="2">Zona B</option>
                <option value="4">Zona C</option>
                <option value="3">Zona D</option>
                <option value="5">Zona E</option>
              </select>
      
            <select placeholder="Seleccionar" v-model="selectedMonth" required @change="getData">
              <option v-for="(month, index) in months" :key="index" :value="index + 1">{{ month }}</option>
             </select>
         
              <select placeholder="Seleccionar" v-model="selectedYear" required @change="getData">
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>
            </div>

            
          
        </div>

        <div class="columns">
          <div class="column"></div>
          <div class="column">Básico</div>
          <div class="column">Integral</div>
          <div class="column">Premium</div>
          <div class="column">UNI 1000</div>
          <div class="column">UNI 2000</div>
          <div class="column">UNI 3000</div>
          <div class="column">UNI 4000</div>
        </div>


        <div v-for="(item, index) in data" :key="index">
          <div class="columns">
            <div class="column">
             
                {{ item.family_group_label }}
             
            </div>
            <div class="column">
              {{item.basico}}
            </div>
            <div class="column">
              {{item.integral}}
            </div>
            <div class="column">
              {{item.premium}}
            </div>
            <div class="column">
            {{ item.uni1000 }}
          </div>
          <div class="column">
            {{ item.uni2000 }}
          </div>
          <div class="column">
            {{ item.uni3000 }}
          </div>
          <div class="column">
            {{ item.uni4000 }}
          </div>
          </div>
        </div>

        
    <div v-if="locations.length" style="margin-top: 20px">
      <p>Localidades: {{ getNames(locations) }}</p>
    </div>
        
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";


export default {
  data() {
    return {
      zone: 1,
      tipo_afiliado: 2,
      locations: [],
      selectedMonth: null,
      selectedYear: null,
        months: [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
            'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ],
      years: [2024, 2025, 2026],
      data: [
        {
          family_group_label: "Individual Junior (18 a 30 años)",
          family_group: "individual_junior",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
       
        {
          family_group_label: "Individual Joven (31 a 45 años)",
          family_group: "individual_joven",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
       
         {
          family_group_label: "Individual Adulto (46 a 64 años) ",
          family_group: "individual_adulto",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },

        {
          family_group_label: "Cónyuge Junior (18 a 30 años)",
          family_group: "matrimonio_junior",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
       
          {
          family_group_label: "Cónyuge Joven (31 a 45 años)",
          family_group: "matrimonio_joven",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
          

         {
          family_group_label: "Cónyuge Adulto (46 a 64 años)",
          family_group: "matrimonio_adulto",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
        
        {
          family_group_label: "Primer hijo dentro del GFP",
          family_group: "hijo_adicional",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
        {
          family_group_label: "Segundo hijo dentro del GFP",
          family_group: "dos_hijos_adicional",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
        {
          family_group_label: "A partir del tercer hijo dentro del GFP",
          family_group: "mas_tres_hijos",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
        
       
       
        {
          family_group_label: "Por cada mayor de 65 años",
          family_group: "mayor65",
          basico: 0,
          integral: 0,
          premium: 0,
          uni1000: 0,
          uni2000: 0,
          uni3000: 0,
          uni4000: 0,
        },
      ],
    };
  },
  methods: {
    selectedMonthName() {
      if (this.selectedMonth !== null) {
        return this.months[this.selectedMonth - 1]; // Restamos 1 porque los índices en JavaScript comienzan en 0
      } else {
        return ''; // Devuelve un string vacío si no se ha seleccionado ningún mes
      }
    },

   getData() {
  
      axios
        .get("https://api.osfatun.com.ar/api/v1/getplan", {
          params: {
            tipo_afiliado: 1,
            zone_id: this.zone,
            year: this.selectedYear,
            month: this.selectedMonth
          },
        })
        .then((data) => {
           console.log(data.data)


             // individual junior
            this.data['0']['basico'] = data.data['4'] ? data.data['4']['basico'] : 0;
            this.data['0']['integral'] = data.data['4'] ? data.data['4']['integral'] : 0;
            this.data['0']['premium'] = data.data['4'] ? data.data['4']['premium'] : 0;
            this.data['0']['uni3000'] = data.data['4'] ? data.data['4']['uni3000'] : 0;
            this.data['0']['uni4000'] = data.data['4'] ? data.data['4']['uni4000'] : 0;
            this.data['0']['uni2000'] = data.data['4'] ? data.data['4']['uni2000'] : 0;
            this.data['0']['uni1000'] = data.data['4'] ? data.data['4']['uni1000'] : 0;

            // Individual joven
            this.data['1']['basico'] = data.data['3'] ? data.data['3']['basico'] : 0;
            this.data['1']['integral'] = data.data['3'] ? data.data['3']['integral'] : 0;
            this.data['1']['premium'] = data.data['3'] ? data.data['3']['premium'] : 0;
            this.data['1']['uni2000'] = data.data['3'] ? data.data['3']['uni2000'] : 0;
            this.data['1']['uni3000'] = data.data['3'] ? data.data['3']['uni3000'] : 0;
            this.data['1']['uni4000'] = data.data['3'] ? data.data['3']['uni4000'] : 0;
            this.data['1']['uni1000'] = data.data['3'] ? data.data['3']['uni1000'] : 0;

            // Individual Adulto
            this.data['2']['basico'] = data.data['2'] ? data.data['2']['basico'] : 0;
            this.data['2']['integral'] = data.data['2'] ? data.data['2']['integral'] : 0;
            this.data['2']['premium'] = data.data['2'] ? data.data['2']['premium'] : 0;
            this.data['2']['uni1000'] = data.data['2'] ? data.data['2']['uni1000'] : 0;
            this.data['2']['uni2000'] = data.data['2'] ? data.data['2']['uni2000'] : 0;
            this.data['2']['uni3000'] = data.data['2'] ? data.data['2']['uni3000'] : 0;
            this.data['2']['uni4000'] = data.data['2'] ? data.data['2']['uni4000'] : 0;

            // Matrimonio junior
            this.data['3']['basico'] = data.data['8'] ? data.data['8']['basico'] : 0;
            this.data['3']['integral'] = data.data['8'] ? data.data['8']['integral'] : 0;
            this.data['3']['premium'] = data.data['8'] ? data.data['8']['premium'] : 0;
            this.data['3']['uni2000'] = data.data['8'] ? data.data['8']['uni2000'] : 0;
            this.data['3']['uni3000'] = data.data['8'] ? data.data['8']['uni3000'] : 0;
            this.data['3']['uni4000'] = data.data['8'] ? data.data['8']['uni4000'] : 0;
            this.data['3']['uni1000'] = data.data['8'] ? data.data['8']['uni1000'] : 0;

            // Matrimonio joven
            this.data['4']['basico'] = data.data['7'] ? data.data['7']['basico'] : 0;
            this.data['4']['integral'] = data.data['7'] ? data.data['7']['integral'] : 0;
            this.data['4']['premium'] = data.data['7'] ? data.data['7']['premium'] : 0;
            this.data['4']['uni2000'] = data.data['7'] ? data.data['7']['uni2000'] : 0;
            this.data['4']['uni3000'] = data.data['7'] ? data.data['7']['uni3000'] : 0;
            this.data['4']['uni4000'] = data.data['7'] ? data.data['7']['uni4000'] : 0;
            this.data['4']['uni1000'] = data.data['7'] ? data.data['7']['uni1000'] : 0;

            // Matrimonio adulto
            this.data['5']['basico'] = data.data['6'] ? data.data['6']['basico'] : 0;
            this.data['5']['integral'] = data.data['6'] ? data.data['6']['integral'] : 0;
            this.data['5']['premium'] = data.data['6'] ? data.data['6']['premium'] : 0;
            this.data['5']['uni2000'] = data.data['6'] ? data.data['6']['uni2000'] : 0;
            this.data['5']['uni3000'] = data.data['6'] ? data.data['6']['uni3000'] : 0;
            this.data['5']['uni4000'] = data.data['6'] ? data.data['6']['uni4000'] : 0;
            this.data['5']['uni1000'] = data.data['6'] ? data.data['6']['uni1000'] : 0;

            // Un hijo adicional
            this.data['6']['basico'] = data.data['1'] ? data.data['1']['basico'] : 0;
            this.data['6']['integral'] = data.data['1'] ? data.data['1']['integral'] : 0;
            this.data['6']['premium'] = data.data['1'] ? data.data['1']['premium'] : 0;
            this.data['6']['uni2000'] = data.data['1'] ? data.data['1']['uni2000'] : 0;
            this.data['6']['uni3000'] = data.data['1'] ? data.data['1']['uni3000'] : 0;
            this.data['6']['uni4000'] = data.data['1'] ? data.data['1']['uni4000'] : 0;
            this.data['6']['uni1000'] = data.data['1'] ? data.data['1']['uni1000'] : 0;

            // Dos hijos adicionales
            this.data['7']['basico'] = data.data['0'] ? data.data['0']['basico'] : 0;
            this.data['7']['integral'] = data.data['0'] ? data.data['0']['integral'] : 0;
            this.data['7']['premium'] = data.data['0'] ? data.data['0']['premium'] : 0;
            this.data['7']['uni2000'] = data.data['0'] ? data.data['0']['uni2000'] : 0;
            this.data['7']['uni3000'] = data.data['0'] ? data.data['0']['uni3000'] : 0;
            this.data['7']['uni4000'] = data.data['0'] ? data.data['0']['uni4000'] : 0;
            this.data['7']['uni1000'] = data.data['0'] ? data.data['0']['uni1000'] : 0;

            // Más de tres hijos adicionales
            this.data['8']['basico'] = data.data['5'] ? data.data['5']['basico'] : 0;
            this.data['8']['integral'] = data.data['5'] ? data.data['5']['integral'] : 0;
            this.data['8']['premium'] = data.data['5'] ? data.data['5']['premium'] : 0;
            this.data['8']['uni2000'] = data.data['5'] ? data.data['5']['uni2000'] : 0;
            this.data['8']['uni3000'] = data.data['5'] ? data.data['5']['uni3000'] : 0;
            this.data['8']['uni4000'] = data.data['5'] ? data.data['5']['uni4000'] : 0;
            this.data['8']['uni1000'] = data.data['5'] ? data.data['5']['uni1000'] : 0;

            // Mayor de 65
            this.data['9']['basico'] = data.data['9'] ? data.data['9']['basico'] : 0;
            this.data['9']['integral'] = data.data['9'] ? data.data['9']['integral'] : 0;
            this.data['9']['premium'] = data.data['9'] ? data.data['9']['premium'] : 0;
            this.data['9']['uni2000'] = data.data['9'] ? data.data['9']['uni2000'] : 0;
            this.data['9']['uni3000'] = data.data['9'] ? data.data['9']['uni3000'] : 0;
            this.data['9']['uni4000'] = data.data['9'] ? data.data['9']['uni4000'] : 0;
            this.data['9']['uni1000'] = data.data['9'] ? data.data['9']['uni1000'] : 0;
         
        })
        .catch((error) => {
          console.log(error);
        });

           axios
        .get(
          "https://api.osfatun.com.ar/api/v1/locationsByZone/" + this.zone,
          {}
        )
        .then((response) => {
          
          this.locations = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getNames(locations) {
      return locations.map((location) => location.name).join(", ");
    },

 
  },

   mounted() {
     const currentDate = new Date();
    this.selectedYear = currentDate.getFullYear();
    this.selectedMonth = currentDate.getMonth() + 1;
    this.getData();
    this.getNames();
  },
};
</script>

<style>
#label {
  padding-top: 2rem;
}

.columns:not(:last-child) {
  border-bottom: 1px solid #ccc;
}

.column {
 padding-top: 20px;
  border-bottom: 1px solid #ccc;
}

.input-ul {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
  margin-bottom: 10px;
}
.input-ul li {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
}
.input-ul li:last-child {
  margin-right: 0;
}

input {
  background-color: transparent;
  /* width: initial!important; */
}

select,
input[type="text"],
input[type="email"],
input[type="number"] {
  border-radius: 0;
  border: 0;
  border-bottom: 3px solid #fbaf33;
  font-size: 17px !important;
  margin-right: 10px;
  color: #00758f;

}

.input-ul li:first-child,
.input-ul li:last-child {
  font-size: 24px;
  color: #00758f;
}

h1.title {
  font-weight: bold;
  font-size: 24px;
  color: #00758f;
  line-height: 1.9rem;
}


</style>
